import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from './Navbar'

const WellnessKit = () => {
  const navigate = useNavigate()

  const handlePayment = () => {
    navigate('/confirmation-form') // replace with your route
  }

  const planCardStyle = {
    backgroundColor: '#e6f3ff',
    borderRadius: '15px',
    padding: '30px',
    marginBottom: '30px',
    border: 'none',
    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
    position: 'relative',
    overflow: 'hidden',
  }

  const titleStyle = {
    color: '#2D5272',
    fontSize: '32px',
    fontWeight: '600',
    marginBottom: '8px',
    lineHeight: '1.3',
    fontFamily: 'Inter',
  }

  const subtitleStyle = {
    color: '#4a6fa5',
    marginBottom: '20px',
    lineHeight: '1.4',
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: '30px',
  }

  const priceStyle = {
    color: '#2c5282',
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '20px',
  }

  const featureListStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
  }

  const featureStyle = {
    padding: '0',
    margin: '0',
  }

  const featureItemStyle = {
    color: '#4a5568',
    fontSize: '0.95rem',
    marginBottom: '8px',
    paddingLeft: '15px',
    position: 'relative',
    lineHeight: '1.4',
  }

  const buttonStyle = {
    backgroundColor: '#4a6fa5',
    color: 'white',
    border: 'none',
    borderRadius: '25px',
    padding: '10px 25px',
    fontSize: '0.95rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  }

  const illustrationStyle = {
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: '0.3',
    width: '120px',
    height: '120px',
  }

  const learnMoreStyle = {
    fontSize: '14px',
    color: '#007bff',
    cursor: 'pointer',
    textDecoration: 'underline',
    marginTop: '10px',
    display: 'inline-block',
  }

  const offerBoxStyle = {
    background: '#2E5272CF',
    color: 'white',
    padding: '15px',
    width: '100%',
    borderRadius: '5px',
    marginTop: '20px',
    lineHeight: '1.6',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }

  return (
    <>
      <Navbar />
      <div className='container-fluid py-4 bg-container'>
        <div className='row'>
          <div className='col-12'>
            <div className='card' style={planCardStyle}>
              <div className='row align-items-center'>
                <div className='col-lg-12 col-md-7 col-12'>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{ flex: '1 1 70%' }}>
                      <h2 style={titleStyle}>
                        Tesla Bird Mental Wellness Card Kit
                      </h2>
                      <p style={subtitleStyle}>
                        Price: ₹2499/- | Empower Your Mind, Daily
                      </p>
                      <p style={priceStyle}>
                        In today’s fast-paced world, mental wellness is
                        paramount. The Tesla Bird Mental Wellness Card Kit is
                        your daily companion, designed to enhance emotional
                        resilience, focus, and self-care.
                      </p>
                      <p style={priceStyle}>
                        Whether you’re a student, professional, parent, or
                        someone seeking balance, this kit offers practical tools
                        aligned with global mental health guidelines.
                      </p>
                    </div>

                    <div style={{ flex: '0 0 auto' }}>
                      <button
                        style={buttonStyle}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = '#3a5a8a'
                          e.currentTarget.style.transform = 'translateY(-2px)'
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = '#4a6fa5'
                          e.currentTarget.style.transform = 'translateY(0)'
                        }}
                        onClick={handlePayment}
                      >
                        Pay Now
                      </button>
                    </div>
                  </div>

                  {/* Extended Section */}

                  <div style={{ marginTop: '15px' }}>
                    <h2
                      style={{
                        color: '#2c4f6e',
                        fontSize: '20px',
                        fontWeight: '600',
                        marginTop: '25px',
                        marginBottom: '15px',
                      }}
                    >
                      What's Inside the Kit:
                    </h2>

                    <div
                      style={{
                        color: '#2c4f6e',
                        fontSize: '15px',
                        lineHeight: '1.5',
                      }}
                    >
                      <p style={{ marginBottom: '5px' }}>
                        <strong>1. 100 Mental Wellness Overview Cards:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Gain clear insights into over 100 mental health
                        conditions, including anxiety, depression, ADHD, and
                        more. Based on WHO Mental Health Framework and NIMHANS
                        India guidelines.
                      </p>

                      <p style={{ marginBottom: '5px' }}>
                        <strong>2. Brain Teasers Cards:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Engage with puzzles and logic tasks to boost memory and
                        cognitive flexibility.
                      </p>

                      <p style={{ marginBottom: '5px' }}>
                        <strong>3. Meditation & Breathing Cards:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Access guided techniques like box breathing and
                        grounding meditations for instant stress relief.
                      </p>

                      <p style={{ marginBottom: '5px' }}>
                        <strong>4. Mind Cognitive Cards:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Develop emotional intelligence and resilience through
                        daily prompts.
                      </p>

                      <p style={{ marginBottom: '5px' }}>
                        <strong>5. Mental Wellness Planner & Journals:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Track moods, habits, and reflections with structured
                        weekly planners.
                      </p>

                      <p style={{ marginBottom: '5px' }}>
                        <strong>6. Gratification Cards:</strong>
                      </p>
                      <p
                        style={{
                          marginLeft: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Foster joy and connection with daily gratitude
                        exercises.
                      </p>
                    </div>

                    <div className='row mt-4'>
                      <div className='col-md-6'>
                        <h2
                          style={{
                            color: '#2c4f6e',
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '15px',
                          }}
                        >
                          Who This is For:
                        </h2>
                        <ul
                          style={{
                            color: '#2c4f6e',
                            fontSize: '15px',
                            paddingLeft: '20px',
                          }}
                        >
                          <li style={{ marginBottom: '8px' }}>
                            Students managing academic stress
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Professionals facing workplace challenges
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Mental health facilitators and therapists
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Families aiming for emotional well-being
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Anyone seeking daily mental clarity and balance
                          </li>
                        </ul>
                      </div>

                      <div className='col-md-6'>
                        <h2
                          style={{
                            color: '#2c4f6e',
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '15px',
                          }}
                        >
                          Why It Works:
                        </h2>
                        <ul
                          style={{
                            color: '#2c4f6e',
                            fontSize: '15px',
                            paddingLeft: '20px',
                          }}
                        >
                          <li style={{ marginBottom: '8px' }}>
                            Rooted in cognitive science and behavioral
                            psychology
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Aligns with NIMHANS and WHO mental well-being
                            practices
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            Portable, non-digital, and user-friendly
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className='mt-4'>
                      <h2
                        style={{
                          color: '#2c4f6e',
                          fontSize: '20px',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '15px',
                        }}
                      >
                        <span style={{ marginRight: '8px' }}>📞</span> Mental
                        Health Support Resources:
                      </h2>
                      <p
                        style={{
                          color: '#2c4f6e',
                          fontSize: '15px',
                          marginBottom: '10px',
                        }}
                      >
                        If you or someone you know needs professional mental
                        health support:
                      </p>
                      <p
                        style={{
                          color: '#2c4f6e',
                          fontSize: '15px',
                          marginBottom: '5px',
                          fontWeight: '500',
                        }}
                      >
                        TELE-MANAS India Toll-Free 24/7 Helpline: 14416 or
                        1-800-891-4416
                      </p>
                      <p
                        style={{
                          color: '#2c4f6e',
                          fontSize: '15px',
                          marginBottom: '20px',
                        }}
                      >
                        Provides free, round-the-clock mental health support in
                        20+ languages across India.
                      </p>
                    </div>

                    <div className='mt-3'>
                      <h2
                        style={{
                          color: '#2c4f6e',
                          fontSize: '20px',
                          fontWeight: '600',
                          marginBottom: '15px',
                        }}
                      >
                        Enhance Your Life With:
                      </h2>
                      <ul
                        style={{
                          color: '#2c4f6e',
                          fontSize: '15px',
                          paddingLeft: '20px',
                        }}
                      >
                        <li style={{ marginBottom: '8px' }}>Improved focus</li>
                        <li style={{ marginBottom: '8px' }}>
                          Emotional balance
                        </li>
                        <li style={{ marginBottom: '8px' }}>
                          Daily self-care routines
                        </li>
                        <li style={{ marginBottom: '8px' }}>
                          Increased self-awareness
                        </li>
                        <li style={{ marginBottom: '8px' }}>
                          Cultivated Gratitude
                        </li>
                      </ul>
                      {/* <div
                            className='container-fluid'
                            style={{ backgroundColor: '#2E5272CF' }}
                          >
                            Launch Offer: ₹1499/- Only Eco-friendly packaging,
                            ideal for personal use or gifting Nationwide
                            shipping available | Bulk and corporate orders
                            welcome 📞 Contact: Tesla Bird Experience, India |
                            +91 97406 33719
                          </div> */}
                    </div>
                    <div
                      className='mt-4'
                      style={offerBoxStyle}
                      // style={{
                      //   background: '#2E5272CF',
                      //   color: 'white',
                      //   fontSize: '15px',
                      //   lineHeight: '1.6',
                      //   fontFamily: 'Inter',
                      // }}
                    >
                      <strong>Launch Offer: ₹2499/- Only</strong>
                      <br />
                      Eco-friendly packaging, ideal for personal use or gifting
                      <br />
                      Nationwide shipping available | Bulk and corporate orders
                      welcome
                      <br />
                      <span role='img' aria-label='phone'>
                        📞
                      </span>
                      Contact: Tesla Bird Experience, India | +91 97406 33719
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WellnessKit
